import { useCourseDelete } from '@/module/Author/Course';

import { DeleteButton } from '@/core/components';

import { Id, useDelete } from '@feature/utils';

interface CourseDeleteButtonProps {
  courseId: Id;
}

export function CourseDeleteButton({ courseId }: CourseDeleteButtonProps) {
  const mutation = useCourseDelete(courseId);
  const deleteProps = useDelete({
    mutation,
    navigateTo: { to: '..' },
  });

  return (
    <DeleteButton
      size="xs"
      {...deleteProps}
    />
  );
}
